import React, { useCallback } from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

const HeroAnimated = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const options = {
    fullScreen: { enable: false },
    fpsLimit: 60,
    particles: {
      number: { value: 60, density: { enable: true, area: 900 } },
      color: { value: ['#A855F7', '#22D3EE', '#818CF8'] },
      shape: { type: 'circle' },
      opacity: { value: 0.45, random: { enable: true, minimumValue: 0.15 } },
      size: { value: { min: 1, max: 3 } },
      move: { enable: true, speed: 0.6, direction: 'none', outMode: 'out' },
      links: { enable: true, distance: 130, color: '#A855F7', opacity: 0.12, width: 1 },
    },
    interactivity: {
      events: { onHover: { enable: true, mode: 'repulse' }, onClick: { enable: false } },
      modes: { repulse: { distance: 80 } },
    },
    detectRetina: true,
  };

  return (
    <div className="absolute inset-0 z-0 pointer-events-none">
      <Particles init={particlesInit} options={options} />
    </div>
  );
};

export default HeroAnimated;
